import React from 'react';
import {AppTitle, AppText, AppSubtitle, AppCardTitle} from '../../../../Presentation/components/ui/Typography';
import Button from '../../../../Presentation/components/ui/Button';
import {UserPlus, RefreshCw} from 'lucide-react';
import {useAuthorization} from '../../../auth/hooks/useAuthorization';
import {PERMISSIONS} from '../../../../constants/permissions';

interface UsersPageHeaderProps {
  onAddUser?: () => void;
  onRefresh?: () => void;
  refreshing?: boolean;
  totalUsers?: number;
}

export const UsersPageHeader: React.FC<UsersPageHeaderProps> = ({
  onAddUser,
  onRefresh,
  refreshing = false,
  totalUsers = 0
}) => {
  const {hasPermission} = useAuthorization();
  return (
    <div className="flex justify-between items-start py-4">
      <div className="space-y-3">
        <AppTitle className="mb-3">
          إدارة المستخدمين
        </AppTitle>
        <div className="space-y-2">
          <AppText className="text-gray-600 leading-relaxed">
            إدارة مستخدمي لوحة التحكم والأدوار والصلاحيات
          </AppText>
          {totalUsers > 0 && (
            <AppCardTitle className="text-brand-600">
              ({totalUsers} مستخدم)
            </AppCardTitle>
          )}
        </div>
      </div>
      <div className="flex items-center gap-4">
        <Button
          variant="outline"
          onClick={onRefresh}
          isLoading={refreshing}
          size="medium"
          icon={<RefreshCw className="w-5 h-5" />}
        >
          تحديث
        </Button>
        <Button
          variant="primary"
          permission={PERMISSIONS.CREATE_USERS}
          onClick={onAddUser}
          size="medium"
          icon={<UserPlus className="w-5 h-5" />}
        >
          إضافة مستخدم
        </Button>
      </div>
    </div>
  );
};
